import React, { useState, useEffect } from 'react'
import FrequentlyAskedQuestions from '../../components/faqs'
import PriceHero from './components/hero'
import PlanCategories from './components/planCategories'
import PlansTable from './components/plansTable'
import { getRequest } from '../../resources/api-request'
import { useQuery } from 'react-query'
import { useLocation } from 'react-router-dom'
import { useMyContext } from '../../components/newPlans/context'

const Pricing = () => {
    const [yearOrMonth, setYearOrMonth] = useState<string>('yearly')
            const [amount, setAmount] = useState<number | any>(60000);
            const [page, setPage] = useState<any>()
            const location = useLocation()
    useEffect(() => {
        const getSubscription = async () => {
            const response = await getRequest('subscription-plans');
            setAmount(response?.data?.headers?.[1].amountYear *response?.data?.headers?.[1].discount)
        }

        getSubscription();
    })

    useEffect(() => {
      const params = new URLSearchParams(location.search);
      const getPage = params.get('page');
      setPage(getPage);
    }, [location.search])
    

    
    const faqsForHomePage = [
        {
            question: 'Can I track my inventory levels in real-time?',
            answer: 'Yes, our software offers real-time tracking of inventory levels, allowing you to make informed decisions based on the latest data.'
        },
        {
            question: 'Does the software support financial reporting and analysis?',
            answer: 'Absolutely. Our software provides robust financial reporting tools, offering insights into your business performance.'
        },
        {
            question: 'Is the software scalable to accommodate business growth?',
            answer: 'Yes, our solution is designed to scale with your business. You can easily adapt it to meet the growing needs of your enterprise.'
        },
        {
            question: 'Is there customer support available for assistance?',
            answer: 'Yes, we provide dedicated customer support to assist you with any queries or issues you may encounter while using our software.'
        },
        {
            question: 'Can I try the software before committing to a purchase?',
            answer: 'Certainly. We offer a basic plan which is free for you to explore the features and functionalities of our software before making a commitment.'
        },
        {
            question: 'How secure is my data when using your software?',
            answer: 'We prioritize data security. Our software employs robust security measures to protect your sensitive information, ensuring confidentiality and integrity.'
        },
        {
            question: 'What types of Businesses can I manage with KlakPad?',
            answer: 'You can manage a wide range of businesses with Klakpad, including department stores, grocery stores, bookstores, pharmacies, boutiques, electronic shops, beauty supply stores, and many other retail or product-based businesses. If your business involves selling products, managing inventory, or handling customer transactions, Klakpad is a perfect fit.    '
        },
         {
            question: ' Can I import existing inventory data into KlakPad, and what formats are supported?',
            answer: 'Yes, you can. Klakpad Sella allows you to import your existing inventory data seamlessly using the CSV format. This makes it easy to migrate from your current system and get started quickly without losing your existing records'
        },
        {
            question: 'Does KlakPad sella support barcode scanning ',
            answer: 'Yes, KlakPad sella does support barcode scanning! You can use any compatible barcode scanner to quickly scan items into your system whether adding new inventory, processing sales at the point of checkout, or performing automated inventory counts. This feature helps streamline operations and reduce manual entry errors'
        },
         {
            question: 'Can I manage multiple outlets or storage locations within KlakPad',
            answer: 'Yes, KlakPad allows you to manage multiple outlets or storage locations with ease. You can set up each outlet or warehouse separately, track inventory levels by location, transfer stock between them, and view both individual and consolidated reports  all from one dashboard.'
        },

    ]
    return (
        <>
            <PriceHero amount={amount} setAmount={setAmount} setYearOrMonth={setYearOrMonth} yearOrMonth={yearOrMonth} 
            page={page}/>
            <PlansTable yearOrMonth={yearOrMonth} />
            <PlanCategories />
            <FrequentlyAskedQuestions faqs={faqsForHomePage} />
        </>
    )
}

export default Pricing
